import { urlEncodeUtil } from 'helpers/url-encode';
import { IConfirmationApiService } from 'types/confirmation-api';
import { HttpResponse } from 'types/http-response';
import { IApiService } from 'types/api-service';

export class ConfirmationApi implements IConfirmationApiService {
    constructor(private readonly apiService: IApiService) {}

    confirmation(agreementGuid: string): Promise<HttpResponse<void>> {
        return this.apiService
            .request<void>({
                method: 'GET',
                url: '/MarketingConfirmation/Agree',
                params: {
                    agreementId: agreementGuid,
                },
                paramsSerializer: urlEncodeUtil,
            })
            .then((response) => response);
    }
}
